"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ARROW_DIRECTION = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _boxShadowMixin = _interopRequireDefault(require("./boxShadowMixin"));

var ARROW_DIRECTION = {
  UP: 'up',
  DOWN: 'down'
};
exports.ARROW_DIRECTION = ARROW_DIRECTION;
var Arrow = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1q6tmli0"
})(_boxShadowMixin.default, " background-color:", function (_ref) {
  var selectors = _ref.selectors;
  return selectors.color('white');
}, ";position:absolute;", function (_ref2) {
  var arrowDirection = _ref2.arrowDirection;
  return arrowDirection === ARROW_DIRECTION.DOWN ? 'top' : 'bottom';
}, ":-4px;left:12px;width:8px;height:8px;transform:rotate(45deg);border:1px solid ", function (_ref3) {
  var selectors = _ref3.selectors;
  return selectors.color('accent3');
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BvcG92ZXItbGVnYWN5L0Fycm93LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVUyQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvc3VibW9kdWxlcy9wb3BvdmVyLWxlZ2FjeS9BcnJvdy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCBib3hTaGFkb3dNaXhpbiBmcm9tICcuL2JveFNoYWRvd01peGluJztcblxuZXhwb3J0IGNvbnN0IEFSUk9XX0RJUkVDVElPTiA9IHtcbiAgVVA6ICd1cCcsXG4gIERPV046ICdkb3duJ1xufTtcblxuY29uc3QgQXJyb3cgPSBzdHlsZWQoJ2RpdicpYFxuICAke2JveFNoYWRvd01peGlufVxuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IHNlbGVjdG9ycyB9KSA9PiBzZWxlY3RvcnMuY29sb3IoJ3doaXRlJyl9O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICR7KHsgYXJyb3dEaXJlY3Rpb24gfSkgPT5cbiAgICBhcnJvd0RpcmVjdGlvbiA9PT0gQVJST1dfRElSRUNUSU9OLkRPV04gPyAndG9wJyA6ICdib3R0b20nfTogLTRweDtcbiAgbGVmdDogMTJweDtcbiAgd2lkdGg6IDhweDtcbiAgaGVpZ2h0OiA4cHg7XG4gIHRyYW5zZm9ybTogcm90YXRlKDQ1ZGVnKTtcbiAgYm9yZGVyOiAxcHggc29saWQgJHsoeyBzZWxlY3RvcnMgfSkgPT4gc2VsZWN0b3JzLmNvbG9yKCdhY2NlbnQzJyl9O1xuYDtcblxuQXJyb3cuZGlzcGxheU5hbWUgPSAnQXJyb3cnO1xuQXJyb3cucHJvcFR5cGVzID0ge1xuICBhcnJvd0RpcmVjdGlvbjogUHJvcFR5cGVzLm9uZU9mKE9iamVjdC52YWx1ZXMoQVJST1dfRElSRUNUSU9OKSksXG4gIHNlbGVjdG9yczogUHJvcFR5cGVzLmFueS5pc1JlcXVpcmVkXG59O1xuXG5leHBvcnQgZGVmYXVsdCBBcnJvdztcbiJdfQ== */"));
Arrow.displayName = 'Arrow';
Arrow.propTypes = {
  arrowDirection: _propTypes.default.oneOf(Object.values(ARROW_DIRECTION)),
  selectors: _propTypes.default.any.isRequired
};
var _default = Arrow;
exports.default = _default;